import PropTypes from "prop-types";
import React, { useState } from "react";
import StatusCell from "../StatusCell.jsx";
import TimeOffRequestDialog from "../TimeOffRequestDialog.jsx";

const TimeOffRequestWOPStatus = (props) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleClickDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleClickDialogClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setIsDialogOpen(false);
  };

  return (
    <div data-testid="time-off-request-wop-status-component">
      <span data-testid="time-off-request-wop-status-text-link" className="text-link" onClick={handleClickDialogOpen}>
        <StatusCell status={props.timeOffRequest.visibleStatus} isAdminPage={props.isAdminPage} />
      </span>
      {isDialogOpen && (
        <TimeOffRequestDialog
          timeOffRequest={props.timeOffRequest}
          isDialogOpen={isDialogOpen}
          handleClickDialogOpen={handleClickDialogOpen}
          handleClickDialogClose={handleClickDialogClose}
          isAdminPage={props.isAdminPage}
          isDesktopView={true}
        />
      )}
    </div>
  );
};

TimeOffRequestWOPStatus.propTypes = {
  timeOffRequest: PropTypes.object.isRequired,
  isAdminPage: PropTypes.bool.isRequired,
};

export default TimeOffRequestWOPStatus;
